import { useState } from 'react';
import './token-modal-confirm.css';
import { AlertTriangle, Lock, Shield } from 'lucide-react';
import { useGetTokenSelector } from '../../../../hooks';
import { Modal, ModalProps } from '../../../modal';

interface TokenConfirmModalProps {
  isOpen: boolean;
  close: ModalProps['close'];
  tokenNumber: number;
  onConfirm: () => void;
  onCancel: () => void;
  leagueName?: string;
  mode?: 'main' | 'arena';
}

const TokenConfirmModal = ({
  isOpen,
  close,
  tokenNumber,
  onConfirm,
  onCancel,
  leagueName = 'Liga',
  mode = 'main',
}: TokenConfirmModalProps) => {
  const { selectTokenWithFeedback, isSelecting } = useGetTokenSelector(mode);

  const [message, setMessage] = useState<string | null>(null);

  const handleClick = async () => {
    const result = await selectTokenWithFeedback({
      idToken: tokenNumber,
      mode,
    });

    setMessage(result.message);

    if (result.success) {
      onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} close={close} onCancel={onCancel}>
      <div className="tokenConfirmModal-header">
        <div className="tokenConfirmModal-iconWrapper">
          <Shield className="tokenConfirmModal-icon" stroke="#000011" />
        </div>
      </div>

      <h2 className="tokenConfirmModal-title">Confirmar Selección de Token</h2>

      <div className="tokenConfirmModal-tokenBox">
        <div className="tokenConfirmModal-tokenLabel">Token Seleccionado</div>
        <div className="tokenConfirmModal-tokenNumber">#{tokenNumber}</div>
      </div>

      <div className="tokenConfirmModal-warning">
        <div className="tokenConfirmModal-warningRow">
          <AlertTriangle
            className="tokenConfirmModal-warningIcon"
            stroke="#F31000"
          />

          <div>
            <p className="tokenConfirmModal-warningTitle">
              ⚠️ Decisión Permanente
            </p>

            <p className="tokenConfirmModal-warningText">
              Una vez canjeado, este token quedará{' '}
              <strong className="highlight">bloqueado permanentemente</strong>{' '}
              para Liga {leagueName}. No podrás modificar tu selección ni
              recuperar la tarjeta utilizada.
            </p>
          </div>
        </div>
      </div>

      <div className="tokenConfirmModal-info">
        <div className="tokenConfirmModal-infoRow">
          <Lock className="tokenConfirmModal-infoIcon" stroke="#90F7FF" />

          <p className="tokenConfirmModal-infoText">
            Este token será registrado en tu colección de forma inmediata y
            participará en el sorteo al finalizar la temporada. Asegúrate de que
            sea tu elección definitiva.
          </p>
        </div>
      </div>

      <div className="tokenConfirmModal-actions">
        <button
          onClick={onCancel}
          disabled={isSelecting}
          className="tokenConfirmModal-btnCancel"
        >
          Cancelar
        </button>

        <button
          onClick={handleClick}
          disabled={isSelecting}
          className="tokenConfirmModal-btnConfirm"
        >
          {isSelecting ? 'Confirmando...' : 'Confirmar'}
        </button>
      </div>

      {message && <p>{message}</p>}
    </Modal>
  );
};

export default TokenConfirmModal;
